import React from 'react';
import { CharityList, SearchResult, CharityDetailsHeading, ClearList } from '../style';
import PropTypes from 'prop-types';

class AddCharityWeb extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const { charityList } = this.props;
        let datasource = [];
        charityList.forEach((item, index) => {
            datasource.push({
                key: index + 1,
                granteeOrgId: item.granteeOrgId,
                charityname: item.legalName,
                address: `${item.addressLine1 ? item.addressLine1 + ",": ""} 
                          ${item.addressLine2 ? item.addressLine2 + ",": ""}
                          ${item.addressLine3 ? item.addressLine3 + ",": ""}
                          ${item.city ? item.city + ",": ""}
                          ${item.state ? item.state + " ": ""}
                          ${item.zip ? item.zip + ",": ""}
                          ${item.country ? item.country: ""}`,
                areainterested: item.interestArea
            })
        })
        const columns = [
            {
                title: 'Charity name',
                dataIndex: 'charityname',
                key: 'charityname'
            },
            {
                title: 'Address',
                dataIndex: 'address',
                key: 'address'
            },
            {
                title: 'Area Interested',
                dataIndex: 'areainterested',
                key: 'areainterested'
            },
            {
                title: 'Add to charity',
                dataIndex: '',
                key: 'addtocharity',
                render: (text, row) => <a onClick={() => this.props.addCharity(row.granteeOrgId, row.charityname)}>Add charity</a>
            }
        ]

        return(
            <SearchResult data-test="addCharityWebBlock">
                <CharityDetailsHeading className="mt-30">Search results</CharityDetailsHeading>
                <CharityList
                    pagination={false}
                    dataSource={datasource}
                    columns={columns}
                />
                <ClearList>
                    <a onClick={() => this.props.clearList()}>Clear all</a>
                </ClearList>
            </SearchResult>
        )
    }
}

AddCharityWeb.propTypes = {
    addCharity: PropTypes.func,
    clearList: PropTypes.func,
    charityList: PropTypes.arrayOf(PropTypes.object)
}

export default AddCharityWeb;